// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodRecipeId } from './FoodRecipe';
import { foodMeasurementTypeId } from './FoodMeasurementType';
import { foodBenchmarkId } from './FoodBenchmark';
import { z } from 'zod';
export const foodMeasurementResultId = (z.number());
export const foodMeasurementResult = z.object({
    id: foodMeasurementResultId,
    recipe_id: foodRecipeId.nullable(),
    measurement_type_id: foodMeasurementTypeId,
    value: z.string().nullable(),
    unit: z.string().nullable(),
    notes: z.string().nullable(),
    created_at: z.date().nullable(),
    updated_at: z.date().nullable(),
    benchmark_id: foodBenchmarkId.nullable(),
});
export const foodMeasurementResultInitializer = z.object({
    id: foodMeasurementResultId.optional(),
    recipe_id: foodRecipeId.optional().nullable(),
    measurement_type_id: foodMeasurementTypeId,
    value: z.string().optional().nullable(),
    unit: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
    benchmark_id: foodBenchmarkId.optional().nullable(),
});
export const foodMeasurementResultMutator = z.object({
    id: foodMeasurementResultId.optional(),
    recipe_id: foodRecipeId.optional().nullable(),
    measurement_type_id: foodMeasurementTypeId.optional(),
    value: z.string().optional().nullable(),
    unit: z.string().optional().nullable(),
    notes: z.string().optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
    benchmark_id: foodBenchmarkId.optional().nullable(),
});
//# sourceMappingURL=FoodMeasurementResult.js.map